import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { canAccess, type ModuleKey } from '@/lib/permissions';

/**
 * Redirects to the dashboard home when the signed-in user's role can't access
 * this module. Backs up the hidden sidebar so a typed URL can't reach a
 * forbidden page. Backend APIs enforce the same rules independently.
 */
export default function ModuleGuard({ module, children }: { module: ModuleKey; children: React.ReactNode }) {
  const { profile } = useAuth();
  if (profile && !canAccess(profile.role, module)) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
